import React, {PureComponent} from 'react';
import { Modal as ModalBootstrap, Button } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';

const defaultValues = {
  messageText:
    'No fue posible realizar la operación en este momento. Por favor intente más tarde.',
  messageType: 'error'
};

class Modal extends PureComponent{

  constructor(props) {
    super(props);
    this.state = {
      isRedirect: false
    };
  }

  redirectTo = () => {
    const {closeErrorModal} = this.props;
    closeErrorModal();
    this.setState(state => ({ isRedirect: !state.isRedirect }));
  };

  render() {
    const { messageText, show, closeErrorModal , redirect} = this.props;

    if(this.state.isRedirect){
      this.setState(state => ({ isRedirect: !state.isRedirect }));
      if(redirect !== ''){
        return <Redirect to={redirect} />;
      }
    }

    window.top.postMessage(
      { scrollToTop: true }, 
      process.env.REACT_APP_PARENT_DOMAIN
    );

    return (
      <ModalBootstrap show={show} onHide={closeErrorModal}>
        <ModalBootstrap.Body>
          <p>{messageText || defaultValues.messageText}</p>
        </ModalBootstrap.Body>
        <ModalBootstrap.Footer>
          <Button onClick={this.redirectTo} type="submit" className="dap_btn-primary">
            Cerrar
          </Button>
        </ModalBootstrap.Footer>
      </ModalBootstrap>
    );
  }
}

export default Modal;
